import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import bengkel from "../../../Assets/Projects/website/Desabengkel.png";
import bengkel1 from "../../../Assets/Projects/website/Desabengkel1.jpeg";
import bengkel3 from "../../../Assets/Projects/website/Desabengkel3.png";
import bengkel2 from "../../../Assets/Projects/website/Desabengkel2.jpeg";
import bengkel4 from "../../../Assets/Projects/website/Desabengkel4.jpeg";

function DesaBengkel() {
  return (
    <ProjectDetailCard
      title="Desa Bengkel Information System"
      image={bengkel1}
      screenshots={[bengkel2, bengkel4, bengkel]}
      description="
      Desa Bengkel Information System is a web-based platform developed to support the digital transformation of Desa Bengkel during the Community Service Program (KKN). The website serves as an integrated information portal that provides village profiles, public announcements, tourism information, and local MSME (Micro, Small, and Medium Enterprises) promotion. Designed with a responsive interface, the system enhances public access to village information while helping local businesses expand their digital presence and improve community engagement.
      "
      technologies={[
        "Laravel",
        "PHP",
        "MySQL",
        "Bootstrap 5",
        "JavaScript",
        "HTML5",
        "CSS3",
        "Git",
        "Responsive Design",
        "Web Development",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          {/* <img src={bengkel} alt="gallery1" />
          <img src={bengkel} alt="gallery2" />
          <img src={bengkel} alt="gallery3" /> */}
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default DesaBengkel;
